export default __webpack_public_path__ + "img/footer/instagram-black.5778914d48336a086b4336ab63cf467c.svg";